import React, { FC } from 'react';
import Button from '@mui/material/Button';
import styles from './ApplicationModal.module.css';
import { Colors } from '../colors';
import generalConfig from '../resources/general.json';

export type ApplicationModalPropsType = {
    isOpen: boolean;
    discardAction?: () => void;
    backAction?: () => void;
};

export const ApplicationModal: FC<{
    modalProperties: ApplicationModalPropsType;
    setModalProperties: (modalProperties: ApplicationModalPropsType) => void;
}> = ({ modalProperties, setModalProperties }) => {
    if (!modalProperties.isOpen) {
        return null;
    }

    const discardAction = () => {
        if (modalProperties.discardAction) {
            closeModal();
            modalProperties.discardAction();
        }
    };
    const backAction = () => {
        if (modalProperties.backAction) {
            closeModal();
            modalProperties.backAction();
        }
    };
    const closeModal = () => {
        setModalProperties({ ...modalProperties, isOpen: false });
    };

    const buttonOverride = {
        '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 51, 142, 0.4)',
            color: 'white',
        },
        ':hover': {
            backgroundColor: Colors.PrimaryLight,
            boxShadow: 'none',
        },
    };
    const buttonVariant = 'contained';
    const discardHeaderText =
        generalConfig.providence.messageProviderDiscardMessage;
    const discardText =
        generalConfig.providence.messageProviderDiscardMessageYes;
    const backText = generalConfig.providence.messageProviderDiscardMessageNo;

    return (
        <div className={styles.applicationModalWrapper}>
            <div className={styles.applicationModal}>
                <p className={styles.applicationModalHeader}>
                    {discardHeaderText}
                </p>
                <p className={styles.applicationModalDescription}>
                    {generalConfig.providence.messageProviderDiscardWarning}
                </p>
                <div className={styles.applicationModalActionButtonBar}>
                    <Button
                        className={styles.applicationModalButton}
                        onClick={discardAction}
                        variant={buttonVariant}
                        sx={buttonOverride}
                    >
                        {discardText}
                    </Button>
                    <Button
                        className={styles.applicationModalButton}
                        onClick={backAction}
                        variant={buttonVariant}
                        sx={buttonOverride}
                    >
                        {backText}
                    </Button>
                </div>
            </div>
        </div>
    );
};
